module.exports = __webpack_public_path__ + "img/ic_alexa_error.7d76df6c.png";